export default "__VITE_ASSET__aT0LzV_R__"